<style scoped lang="scss">

</style>

<template>
<div v-if="applicant">
    <div class="uk-grid">

        <div class="uk-width-small-1-1 uk-width-medium-4-5 uk-align-center">
            <h2>Please Verify Your Personal Information</h2>
        </div>

        <div  class="uk-width-small-1-1 uk-width-medium-4-5 uk-align-center uk-margin-bottom uk-margin-top">
            <div class="uk-grid">
                <div class="uk-width-1-1 uk-margin-bottom">
                    <h4 style="font-weight: bold;">{{ applicant.first_name }} {{ applicant.last_name }}<br/><span v-html="addressString"></span></h4>
                </div>
            </div>
        </div>

        <div class="uk-width-small-1-1 uk-width-medium-4-5 uk-align-center">
            <h3>Is your name and address information correct?</h3>

            <validated-section :errors="errors" field="applicant_confirms_personal">
                <div class="uk-margin-bottom">
                    <input type="radio" :value="true" v-model="personalInformationIsCorrect" class="uk-radio">
                    <span>Yes, I confirm that this is me and my address information is correct.</span>
                </div>

                <div class="uk-margin-bottom">
                    <input type="radio" :value="false" v-model="personalInformationIsCorrect" class="uk-radio">
                    <span>No, this is not me or my address information is incorrect.</span>
                </div>
            </validated-section>



            <div class="uk-margin-top uk-form" v-if="personalInformationIsCorrect === false">
                <label for="">What is incorrect with your name and/or address information?</label>
                <validated-section :errors="errors" field="applicant_personal_verification_notes">
                    <textarea class="uk-textarea uk-form-large uk-width-1-1"
                              style="height: 120px;"
                              rows="10"
                              placeholder="Required if you select 'No' above..."
                              v-model="personalNotes"></textarea>
                </validated-section>

            </div>
        </div>

        <div class="uk-width-small-1-1 uk-width-medium-4-5 uk-align-center" v-if="personalInformationIsCorrect !== false">
            <h2>Please Verify Your Financial Information</h2>
        </div>

        <div class="uk-width-small-1-1 uk-width-medium-4-5 uk-align-center" v-if="personalInformationIsCorrect !== false">
            <table class="uk-table uk-table-striped">
                <thead>
                <tr>
                    <th>Month</th>
                    <th>Due</th>
                    <th>Paid</th>
                    <th>Rent Owed</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="row in application.requested_rent_meta">
                    <td>{{ row.date | moment('MMM YYYY') }}</td>
                    <td>{{ row.due | formatMoney }}</td>
                    <td>{{ row.paid | formatMoney }}</td>
                    <td>{{ row.due  - row.paid | formatMoney }}</td>
                </tr>
                </tbody>
            </table>
        </div>

        <div v-if="landlordUploadedFile && personalInformationIsCorrect !== false" class="uk-width-small-1-1 uk-width-medium-4-5 uk-align-center uk-margin-bottom uk-margin-top">
            <div class="uk-grid">
                <div class="uk-width-1-1 uk-margin-bottom">
                    <h2>Your landlord has uploaded your hardship request for you.</h2>
                    <h4>You may view it below or click 'Done' to complete this application.</h4>
                </div>

                <div class="uk-width-1-1 preview uk-margin-bottom">
                    <iframe v-if="isPdf" style="width: 100%; height: 800px;" :src="url" frameborder="0"></iframe>
                    <preview-documents-modal ref="previewModal"></preview-documents-modal>
                </div>
            </div>
        </div>



        <div class="uk-width-small-1-1 uk-width-medium-4-5 uk-align-center" v-if="personalInformationIsCorrect !== false">
            <h3>Is your financial information correct?</h3>

            <validated-section :errors="errors" field="applicant_confirms_assistance">
                <div class="uk-margin-bottom">
                    <input type="radio" :value="true" v-model="ledgerInformationIsCorrect" class="uk-radio">
                    <span>Yes, I confirm that my financial information is correct.</span>
                </div>

                <div class="uk-margin-bottom">
                    <input type="radio" :value="false" v-model="ledgerInformationIsCorrect" class="uk-radio">
                    <span>No, this information is not correct and I have included notes below.</span>
                </div>
            </validated-section>



            <div class="uk-margin-top uk-form">
                <label for="">Notes:</label>
                <validated-section :errors="errors" field="applicant_verification_notes">
                <textarea class="uk-textarea uk-form-large uk-width-1-1"
                          style="height: 120px;"
                          rows="10"
                          placeholder="Submit notes about this information here..."
                          v-model="notes"></textarea>
                </validated-section>

            </div>
        </div>
    </div>
</div>
</template>

<script>
    import {mapState} from "vuex";
    import moment from 'moment';
    import ValidatedSection from "../../../../../components/Common/ValidatedSection";
    import PreviewDocumentsModal from "../../../../../../dashboard/pages/Documents/PreviewDocumentModal";

    export default {
        name: "LedgerVerificationWithNotes",
        components: {PreviewDocumentsModal, ValidatedSection},
        data() {
            return {
                errors: {},
                personalInformationIsCorrect: null,
                ledgerInformationIsCorrect: null,
                personalNotes: '',
                notes: '',
                noReasons: [

                ],
            }
        },
        watch: {
            personalInformationIsCorrect(newValue) {
                if(newValue) {
                    this.$emit('setLastStep', null);
                }else {
                    this.$emit('setLastStep', 'current');
                }
            }
        },
        computed: {
            document() {
                let document = null;

                _.each(this.documents, doc => {
                    _.each(doc.categories, cat => {
                        if(cat.key === 'hardship-document') {
                            document = doc;
                        }
                    })
                })

                return document;
            },
            isPdf() {
                if (this.document) {
                    return this.document.filename.indexOf('.pdf') !== -1;
                }

                return false;
            },
            url() {
                if(!this.document) return null;
                return `/api/hope/application/${this.application.id}/documents/${this.document.id}/preview`;
            },
            addressString() {
                let string = '';

                if(this.applicant.property_address.line_1) {
                    string += this.applicant.property_address.line_1;
                    if(this.applicant.property_address.line_2) {
                        string += '<br/>' + this.applicant.property_address.line_2;
                    }
                    string += '<br/>' + this.applicant.property_address.city;

                    string += ', ' + this.applicant.property_address.state;

                    string += ' ' + this.applicant.property_address.zip;
                }

                return string;
            },
            landlordUploadedFile() {
                return this.document !== null && this.user !== null && this.document.user_id !== this.user.id;
            },
            forceLastStep() {
                if(this.landlordUploadedFile) return true;
                return false;
            },
            ...mapState('Application', {
                application: state => state.application,
                applicant: state => state.applicant,
                documents: state => state.documents,
                documentRequests: state => state.documentRequests,
            }),
            ...mapState('App', {
                user: state => state.user,
            }),
        },
        mounted() {
            if(this.application) {
                this.init();

                if(this.landlordUploadedFile) {
                    this.$emit('setLastStep', 'current')
                }
            }
        },
        methods: {
            init() {
                if(this.application.applicant_confirms_assistance !== null) {
                    this.ledgerInformationIsCorrect = this.application.applicant_confirms_assistance === 1;
                }
                if(this.application.applicant_confirms_personal !== null) {
                    this.personalInformationIsCorrect = this.application.applicant_confirms_personal === 1;
                }
                this.notes = this.application.applicant_verification_notes;
                this.personalNotes = this.application.applicant_personal_verification_notes;
            },
            openPreview() {
                if(this.document) {
                    let url = `/api/hope/application/${this.application.id}/documents/${this.document.id}/preview`;
                    console.log(this.$refs);
                    this.$refs.previewModal.open(url, this.document);
                }
            },
            async validateStep() {
                this.errors = {};

                if(this.personalInformationIsCorrect === null) {
                    this.errors['applicant_personal_verification_notes'] = ['You must make a selection to continue.'];
                }

                if(this.personalInformationIsCorrect === true) {
                    if(this.ledgerInformationIsCorrect === null) {
                        this.errors['applicant_confirms_assistance'] = ['You must make a selection to continue.'];
                    }
                }else {
                    if(this.personalInformationIsCorrect === false && this.personalNotes === '') {
                        this.errors['applicant_personal_verification_notes'] = ['You must provide notes on what is wrong to continue..'];
                    }

                    if(this.ledgerInformationIsCorrect === false && this.notes === '') {
                        this.errors['applicant_verification_notes'] = ['You must provide notes on what is wrong to continue..'];
                    }
                }


                if(_.size(this.errors) > 0) {
                    return false;
                }

                try {
                    await this.save();
                    return true;
                }catch(e) {
                    return false;
                }
            },
            async save() {
                let data = {
                    applicant_verified_at: this.informationIsCorrect === true ? moment().format('YYYY-MM-DD hh:mm:ss') : null,
                    applicant_confirms_assistance: this.ledgerInformationIsCorrect,
                    applicant_confirms_personal: this.personalInformationIsCorrect,
                    applicant_verification_notes: this.notes,
                    applicant_personal_verification_notes: this.personalNotes,
                }

                try {
                    let r = await axios.put(`/api/hope/applications/${this.application.id}/verify-assistance`, data);
                    await this.$store.dispatch('Application/fetch', this.application.id);
                }catch(e) {
                    this.errors = e.response.data.errors;
                }
            },
        }
    }
</script>
